import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShareTypePipe } from './pipes/share-type.pipe';
import { UserRolePipe } from './pipes/user-role.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [ShareTypePipe, UserRolePipe],
  exports: [ShareTypePipe, UserRolePipe],
  providers: [UserRolePipe],
})
export class SharedUtilsListOfficerModule {}
